import React from "react";
import type Highcharts from "highcharts";
import * as io from "io-ts";
import createGlobalState from "../../lib/createGlobalState";
import useAxisMinMax from "./useAxisMinMax";

const MinMax = io.strict({
  min: io.union([io.number, io.null]),
  max: io.union([io.number, io.null]),
});
export type MinMax = io.TypeOf<typeof MinMax>;

const useYMinMaxState = createGlobalState({
  storage: "session",
  key: "y-axis",
  type: MinMax,
  scoped: true,
});

const useYMinMax = ({
  chartRef,
  yAxisId: yAxisId_,
  scope = "",
}: {
  chartRef: React.RefObject<Highcharts.Chart>;
  yAxisId: string | string[];
  scope?: string;
}) => {
  // we do not play with extremes when multiple axis
  const yAxisId: string | null = React.useMemo(() => {
    if (Array.isArray(yAxisId_) && yAxisId_[0] && yAxisId_.length === 1) return yAxisId_[0];
    if (Array.isArray(yAxisId_)) return null;
    return yAxisId_;
  }, [yAxisId_]);

  const [yUserMinMax, setYUserMinMax] = useYMinMaxState({
    scope: `${yAxisId || "no-id"}${scope && `-${scope}`}`,
    defaultValue: { min: null, max: null },
  });

  return useAxisMinMax({
    chartRef,
    minMax: yUserMinMax,
    setMinMax: setYUserMinMax,
    axisId: yAxisId,
  });
};

export default useYMinMax;
